<template>
<div class="ymda-time-select-container">
  <el-select class="time-select" v-model="timeType">
    <el-option label="Year" value="year"></el-option>
    <el-option label="Month" value="month"></el-option>
    <el-option label="Day" value="day"></el-option>
    <el-option label="Any" value="any"></el-option>
  </el-select>
  <component :is="timeType" v-model="date" @input="emit"></component>
</div>
</template>

<script>
import year from './timeSelector/yearSelector.vue'
import month from './timeSelector/monthSelector.vue'
import day from './timeSelector/daySelector.vue'
export default {
  name: 'YMDAtimeSelect',
  components: {
    year,
    month,
    day
  },
  data () {
    return {
      timeType: 'month',
      date: ''
    }
  },
  methods: {
    log () {
      console.log(this.date)
    },
    emit () {
      this.$emit('input', [this.timeType, this.date])
    }
  }
}
</script>

<style lang="scss" scoped>
.ymda-time-select-container {
  display: flex;
  align-items: center;
  .time-select {
    width: 90px;
  }
}
</style>
